import { render, staticRenderFns } from "./CommentTextarea.vue?vue&type=template&id=3e070a92"
import script from "./CommentTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentTextarea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommentTextarea.vue?vue&type=style&index=0&id=3e070a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports